import { takeLatest, call, put } from "redux-saga/effects";
import {
  engineerUpdated,
  ENGINEER_UPDATE_REQUEST,
  engineerUpdateError,
} from "../../actions/engineers";
import updateEngineer from "../../../../../backend/oncall/partners/engineers/update";

const requestUpdate = function*(action) {
  try {
    yield call(
      updateEngineer,
      action.payload.engineerId,
      action.payload.formData.firstName,
      action.payload.formData.lastName,
      action.payload.formData.workPhone,
      action.payload.formData.cellPhone,
      action.payload.formData.homePhone,
      parseInt(action.payload.formData.regionId, 10),
      action.payload.formData.enabled,
      parseInt(action.payload.formData.workPhonePriority, 10),
      parseInt(action.payload.formData.cellPhonePriority, 10),
      parseInt(action.payload.formData.homePhonePriority, 10),
    );
    yield put(engineerUpdated());
  } catch (error) {
    yield put(engineerUpdateError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(ENGINEER_UPDATE_REQUEST, requestUpdate);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/engineers/request-update.js